<template lang="pug">
footer.escality-footer
  .footer-content
    .text-center.py-2.flex.align-items-center.justify-content-center
        img.mr-2(
          src='@/assets/isotipo-escality.svg',
          alt='ESCALITY',
          width='20',
          style='vertical-align: middle;'
        )
        span.footer-text
          | © {{ year }} ESCALITY -
          a.footer-link(href='https://escality.ai', target='_blank') escality.ai
          |  |
          a.footer-link(href='mailto:soporte@escality.ai') soporte@escality.ai
</template>

<script>
export default {
  name: 'FooterEscality',
  computed: {
    // Calculado, no escrito: el año quedó en 2025 hasta bien entrado 2026.
    year() {
      return new Date().getFullYear();
    },
  },
};
</script>

<style scoped>
.escality-footer {
  background: var(--escality-gray-50);
  color: var(--escality-gray-500);
  border-top: 1px solid var(--escality-gray-200);
  margin-top: auto;
  flex-shrink: 0;
  font-size: var(--escality-text-base);
  width: 100%;
  box-sizing: border-box;
}

.footer-content {
  width: 100%;
  padding: 0 1rem;
}

.footer-text {
  color: var(--escality-gray-600);
  font-size: var(--escality-text-base);
}

.footer-link {
  color: var(--escality-primary);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-link:hover {
  color: var(--escality-primary-dark);
  text-decoration: underline;
}
</style>